import { render, staticRenderFns } from "./ManageFilesHome.vue?vue&type=template&id=68ec0b1b"
import script from "./ManageFilesHome.vue?vue&type=script&lang=js"
export * from "./ManageFilesHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports